frappe.provide("strategic_gears.onboarding");

strategic_gears.onboarding.renderErrorState = function (title, message) {
    $(".web-form-body").remove()
    $(".web-form-footer").remove()
    const errorHtml = `
        <div style="text-align: center; margin-top: 20px;">
            <div style="font-size: 16px; margin-bottom: 15px; color: #c62828;">
                ❌ <strong style="font-size: 18px;">${title}</strong><br><br>
                ${message}
            </div>
        </div>`;
    $(".web-form").html(errorHtml);
}


strategic_gears.onboarding.populateFormData = function() {
    let expiryDateStr = undefined;

    if (window.onboardingPrefillData) {
        let rawExpiry = window.onboardingPrefillData.token_expiry || window.onboardingPrefillData.key_expiry;

        if (rawExpiry) {
            expiryDateStr = frappe.datetime.convert_to_user_tz(rawExpiry);
        }

        frappe.web_form.set_values(window.onboardingPrefillData).then(() => {
            updateLable(window.onboardingPrefillData.branch, window.onboardingPrefillData.nationality)
            const isFixes = window.onboardingPrefillData["__is_fixes"];
            if (isFixes){
                frappe.web_form.fields.forEach(field => {
                    const val = frappe.web_form.get_value(field.fieldname);
    
                    if (val !== null && val !== undefined && val !== '' && val) {
                        frappe.web_form.set_df_property(field.fieldname, 'read_only', 1);
                    }
                });
    
                strategic_gears.onboarding.fixesFormAction(isFixes)
            }
        });
    }

    $(".discard-btn").remove();
    return expiryDateStr;
}


strategic_gears.onboarding.renderFormInstructions = function (is_fixes) {
    var introHtml = ""
    if (is_fixes) {
        let fieldLabels = []
        window.onboardingPrefillData.fixes_required.forEach(field => {
            const field_df = frappe.web_form.fields.filter(fld => fld.fieldname == field.fieldname)
            console.log(window.onboardingPrefillData.fixes_required)
            if (field_df.length > 0) {
                fld_obj = { "label": field_df[0].label, "remark": field.remark }
                fieldLabels.push(fld_obj)
            }
        })
        const listItems = fieldLabels.map(value => `<li><b>${value.label} - ${value.remark}</b></li>`).join('');

        introHtml = `
            <div style="background: #f3f3f3; color: #856404; padding: 15px; border-radius: 8px; margin-top: 10px; font-size: small; border: 1px solid #ffeeba;">
                <b style="font-size: 15px;">Action Required:</b> Please update the following fields:
                <ul style="margin-bottom: 0; padding-left: 20px; margin-top: 8px;">
                    ${listItems}
                </ul>
            </div>
            <div id="webform-countdown" style="font-size: 16px; text-align:center; color: #ff5858; margin-top: 15px; font-weight: bold;"></div> 
        `;
    } else {
        introHtml = `
           <div style="background: #f3f3f3; padding: 15px; border-radius: 8px; margin-top: 10px; font-size: small;">
               <b>Instructions:</b>
               <ul style="margin-bottom: 0; padding-left: 20px;">
                   <li>Fields marked with * are mandatory.</li>
                   <li>Please make sure that any file you attach is named according to the document title (e.g., Passport, National ID, Certificate, etc.) before uploading it.</li>
                   <li><b>Kindly ensure that all the information provided is correct and accurate, as it will be used for company records and official processes.</b></li>
               </ul>
           </div>
           <div id="webform-countdown" style="font-size: 16px; text-align:center; color: #ff5858; margin-top: 15px; font-weight: bold;"></div>
       `;
    }
    $(".web-form-head").append(introHtml);
}


strategic_gears.onboarding.startCountdownTimer = function (expiryDateStr) {
    if (!expiryDateStr) return;

    const cleanDateStr = expiryDateStr.split('.')[0].replace(' ', 'T');
    const targetTime = new Date(cleanDateStr).getTime();
    const timerContainer = document.getElementById('webform-countdown');

    if (!timerContainer) return;

    const countdownInterval = setInterval(() => {
        const now = new Date().getTime();
        const timeRemaining = targetTime - now;

        if (timeRemaining < 0) {
            clearInterval(countdownInterval);
            strategic_gears.onboarding.renderErrorState(__('Link Expired'), __('The time limit to update this form has elapsed. Please request a new link from HR.'));
            return;
        }

        const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        const format = (num) => num.toString().padStart(2, '0');
        timerContainer.innerHTML = `Link Expires in: ${days}d ${format(hours)}h ${format(minutes)}m ${format(seconds)}s`;
    }, 1000);
}

strategic_gears.onboarding.fixesFormAction = function (isFixes) {
    if (!isFixes) {
        return;
    }

    $(".web-form-actions .btn-primary").remove();

    const $customBtn = $(`<button type="button" class="btn btn-primary btn-sm ml-2 custom-submit-btn">Submit Fixes</button>`);

    $(".web-form-actions").last().append($customBtn);

    $customBtn.on("click", function (e) {
        e.preventDefault();

        if (frappe.web_form.validate && !frappe.web_form.validate()) {
            return;
        }

        const values = frappe.web_form.get_values();
        if (!values) return;

        $customBtn.prop('disabled', true);

        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('tkn') || urlParams.get('update_token');

        frappe.call({
            method: "strategic_gears.employee_customization.web_form.employee_onboarding_utils.update_employee_onboarding",
            args: {
                data: values,
                token: token
            },
            callback: function (r) {
                if (!r.exc) {
                    strategic_gears.onboarding.showSuccessPage(isFixes)
                } else {
                    $customBtn.prop('disabled', false);
                }
            }
        });
    });
}

strategic_gears.onboarding.showSuccessPage = function(isFixes) {
    let bodyText = "";

    if (isFixes) {
        bodyText += `You are all caught up for now!`;
    } else {
        bodyText = `Submitted Successfully!`
    }

    $(".success-message").html(bodyText);
    $(".success-footer").empty();

    $(".web-form-container").hide();
    $(".success-page").removeClass("hide");
}

function updateLable(branch, nationality){
    // Only for Riyadh Branch
    if (branch === 'Riyadh' && nationality !== 'Saudi') {
        $('[data-fieldname="national_id_iqama_number"] .control-label').text('Iqama');
        $('[data-fieldname="national_id_iqama_number_attachment_front"] .control-label').text('Iqama Front Copy');
        $('[data-fieldname="national_id_iqama_number_attachment_back"] .control-label').text('Iqama Back Copy');
    }
}